import call from "./call";
import { DocumentsResponse } from "../Models/company";
import { SmartSearchResponse } from "../Models/smartSearch";

export const fetchDocuments = async (
  companyId: string,
  page: number = 1,
  page_size: number = 10,
  sort_order: string = "name",
  sort_direction: string = "asc",
  getAll: boolean = false,
): Promise<DocumentsResponse> => {
  const params: Record<string, string | number | boolean> = {
    ...(getAll && { get_all: true }),
    page,
    page_size,
    sort_order,
    sort_direction,
  };

  const response = await call.get(`/v1/document/company/${companyId}/`, {
    params,
  });
  return response.data;
};

export const uploadCoverSheet = async (
  companyId: string,
  file: File,
): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("company_id", companyId);

  await call.post("/v1/document/cover_sheet/", formData, {
    snack: {
      409: "documents.uploadConflict",
      423: "documents.evaluationInProgress",
      error: "documents.uploadFailed",
    },
  });
};

export const fetchCoverSheet = async (companyId: string): Promise<unknown> => {
  const response = await call.get(`/v1/company/${companyId}/cover_sheet/`, {
    snack: {
      error: "documents.fetchCoverSheetError",
    },
  });
  return response.data;
};

export const updateCoverSheet = async (
  companyId: string,
  data: Record<string, string>,
): Promise<void> => {
  await call.put(`/v1/company/${companyId}/cover_sheet/`, data, {
    snack: {
      error: "documents.updateFailed",
    },
  });
};

export const smartSearchDocuments = async (
  companyId: string,
  search: string,
): Promise<SmartSearchResponse> => {
  const response = await call.get(`/v1/document/smart-search/`, {
    params: {
      search,
      entity: companyId,
    },
  });
  return response.data;
};

export const fetchDocumentLogs = async (
  documentId: number,
): Promise<{ logs: string }> => {
  const response = await call.get(`/v1/document/logs/${documentId}/`, {
    snack: {
      403: "documents.logsForbidden",
      404: "documents.logsNotFound",
      error: "documents.logsFetchFailed",
    },
  });
  return response.data;
};

export const fetchKnowledgeBaseDocumentLogs = async (
  documentId: number,
): Promise<{ logs: string }> => {
  const response = await call.get(
    `/v1/knowledge_base/document/logs/${documentId}/`,
    {
      snack: {
        403: "documents.logsForbidden",
        404: "documents.logsNotFound",
        error: "documents.logsFetchFailed",
      },
    },
  );

  return response.data;
};

export const fetchDocumentChunks = async (
  documentId: number,
): Promise<unknown> => {
  const response = await call.get(`/v1/document/${documentId}/chunks/`, {
    snack: {
      403: "documents.chunksForbidden",
      404: "documents.chunksNotFound",
      error: "documents.chunksFetchFailed",
    },
  });
  return response.data;
};
